import { callAPI, showErrorNotification } from '../../../shared/helpers'

export const ActionTypes = {
  GET_MEMBERS: 'GET_MEMBERS',
  GET_MEMBERS_DATA: 'GET_MEMBERS_DATA',
  GET_INITIAL_MEMBERS_DATA: 'GET_INITIAL_MEMBERS_DATA',
  SET_IS_LOADING: 'SET_IS_LOADING',
  ADD_NEW_GOLFER: 'ADD_NEW_GOLFER',
  HIDE_MEMBER_POPUP: 'HIDE_MEMBER_POPUP',
  DELETE_MEMBER: 'DELETE_MEMBER',
  SHOW_MEMBER_FORM_POPUP_NEW_GOLFER: 'SHOW_MEMBER_FORM_POPUP_NEW_GOLFER',
  SHOW_MEMBER_FORM_POPUP_EDIT_GOLFER: 'SHOW_MEMBER_FORM_POPUP_EDIT_GOLFER',
  HIDE_MEMBER_FORM_POPUP: 'HIDE_MEMBER_FORM_POPUP',
  EDIT_GOLFER: 'EDIT_GOLFER',
}

export const getMembers = (order_by = '', order_type = '', stopIndex, searchInput, isInitial = false) => (dispatch, getState) => {
  const state = getState()
  const loadedMembersCount = state.loadedMembersCount

  const page = loadedMembersCount === 0 ? 1 : Math.floor(stopIndex / loadedMembersCount + 1)
  const params = { order_by, order_type, page, search_input: searchInput }
  const actionType = isInitial ? ActionTypes.GET_INITIAL_MEMBERS_DATA : ActionTypes.GET_MEMBERS

  dispatch({ type: ActionTypes.SET_IS_LOADING })
  callAPI(state.paths.members, 'GET', params)
    .then(data => {
      dispatch({ type: ActionTypes.SET_IS_LOADING })
      dispatch({ type: actionType, data: data })
    })

}

export const getMembersData = () => (dispatch, getState) => {
  const state = getState()
  dispatch({ type: ActionTypes.SET_IS_LOADING })
  callAPI(state.paths.rosterStats)
    .then(data => {
      dispatch({ type: ActionTypes.SET_IS_LOADING })
      dispatch({ type: ActionTypes.GET_MEMBERS_DATA, data: data })
    })
}

export const addMember = (memberParams) => (dispatch, getState) => {
  const state = getState()
  const metadataMap = {
    gender: 'genderMetadata',
    phone: 'phoneMetadata',
    teamId: 'teamIdMetadata',
  }

  const metadata = Object.entries(metadataMap)
    .filter(([paramKey, stateKey]) => state[stateKey] && memberParams[paramKey])
    .reduce((acc, [paramKey, stateKey]) => {
      acc[state[stateKey]] = memberParams[paramKey]
      return acc
    }, {})

  const params = {
    first_name: [memberParams['firstName'] || ''],
    last_name: [memberParams['lastName'] || ''],
    email: [memberParams['email'] || ''],
    index: [''],
    nine_index: [''],
    handicap_network_id: [memberParams['handicapId'] || ''],
    member_metadata: [JSON.stringify(metadata)],
    phone_number: [memberParams['phone'] || ''],
  }
  callAPI(state.paths.addMembers, 'POST', params, {}, 'application/json')
    .then(() => {
      // TBD if handled when member is not added
      dispatch(hideMemberFormPopup())
      dispatch({ type: ActionTypes.ADD_NEW_GOLFER })
    })
    .catch(error => showErrorNotification(error))
}

export const editMember = (memberParams) => (dispatch, getState) => {
  const state = getState()
  const memberId = state.editMember.id
  const metadataMap = {
    gender: 'genderMetadata',
    phone: 'phoneMetadata',
    teamId: 'teamIdMetadata',
  }
  // Phone is sent even when blank so clearing the input clears the stored
  // answer; entries whose metadatum id is missing on this league are skipped.
  const metadataContent = Object.entries(metadataMap)
    .filter(([paramKey, stateKey]) => state[stateKey] && (memberParams[paramKey] || paramKey === 'phone'))
    .map(([paramKey, stateKey]) => {
      const metadataId = state[stateKey]
      const value = memberParams[paramKey] || ''
      return { id: metadataId, answer: value }
    })
  const metadataHash = Object.assign({}, metadataContent)
  const member = {
    first_name: memberParams['firstName'] || '',
    last_name: memberParams['lastName'] || '',
    email: memberParams['email'] || '',
    handicap_network_id: memberParams['handicapId'] || '',
  }
  const params = {
    member: member,
    recompute_handle: true,
    league_metadata_attributes: metadataHash,
    phone_number: [memberParams['phone'] || ''],
  }
  callAPI(state.paths.member.replace('_MEMBER_ID_', memberId), 'PATCH', params, {}, 'application/json')
    .then(() => {
      dispatch(hideMemberFormPopup())
      dispatch({ type: ActionTypes.EDIT_GOLFER })
    })
    .catch(error => showErrorNotification(error))
}

export const deleteMember = (memberId) => (dispatch, getState) => {
  const state = getState()
  callAPI(state.paths.member.replace('_MEMBER_ID_', memberId), 'DELETE', {}, {}, 'application/json')
    .then(() => dispatch({ type: ActionTypes.DELETE_MEMBER }))
}

export const hideMemberPopup = () => (dispatch) => {
  dispatch({ type: ActionTypes.HIDE_MEMBER_POPUP })
}

export const showMemberFormPopupNewGolfer = () => (dispatch) => {
  dispatch({ type: ActionTypes.SHOW_MEMBER_FORM_POPUP_NEW_GOLFER })
}

export const showMemberFormPopupEditGolfer = (memberId) => (dispatch) => {
  dispatch({ type: ActionTypes.SHOW_MEMBER_FORM_POPUP_EDIT_GOLFER, data: memberId })
}

export const hideMemberFormPopup = () => (dispatch) => {
  dispatch({ type: ActionTypes.HIDE_MEMBER_FORM_POPUP })
}
